import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const deleteQuizImages = (imageName) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.MANAGE.DELETE_QUIZ_IMAGE(imageName)
  );
};

export default deleteQuizImages;
